export enum TAXES {
  VAT = .12
};
